import { ViewChildren, QueryList, ElementRef, OnDestroy, ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Observable, Subscription } from "rxjs";
// Material MDC Imports
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatTooltipModule } from "@angular/material/tooltip";
import { BaseSearchResultsComponent } from "../base-search-results.component";
import { SearchResultCardComponent } from "../result-card/search-result-card.component";
import { MatChipsModule } from "@angular/material/chips";
import { IntersectObserverDirective } from "../../../../shared/directives/observer/intersect-observer.directive";
import { IGeofencingSearchValidation } from "../../../model";
import { GeofencingSearchFilterService } from "../../../services/search";

/**
 * List display component for search results
 * Displays search results in a scrollable list layout for sidebar usage
 */
@Component({
  selector: "app-list-search-results",
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./list-search-results.component.html",
  styleUrls: ["./list-search-results.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    SearchResultCardComponent,
    MatTooltipModule,
    MatChipsModule,
    IntersectObserverDirective,
  ],
})
export class ListSearchResultsComponent extends BaseSearchResultsComponent implements OnDestroy {
  private geofencingFilterService = inject(GeofencingSearchFilterService);

  private scrollSyncSub?: Subscription;

  private HIGHLIGHT_TIME: number = 5000; // milliseconds

  @ViewChildren(SearchResultCardComponent, { read: ElementRef }) cards!: QueryList<ElementRef>;

  /**
   * Geofencing precondition of the embeddings search — the landing message and empty state
   * text reflect it before any search has run.
   */
  geofencingValidation$: Observable<IGeofencingSearchValidation> = this.searchQueryService.geofencingValidation$;

  /**
   * Opens the geofencing configuration dialog.
   */
  openGeofencingDialog(): void {
    this.geofencingFilterService.openDialog({});
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.scrollSyncSub = this.searchQueryService.scrollToIndex$.subscribe((index) => {
      if (index !== null) {
        setTimeout(() => {
          const card = this.cards?.toArray()[index];
          if (card) {
            card.nativeElement.scrollIntoView({ behavior: "smooth", block: "center" });
            card.nativeElement.children[0].classList.add("highlighted");
            setTimeout(() => {
              card.nativeElement.children[0].classList.remove("highlighted");
            }, this.HIGHLIGHT_TIME);
          }
        });
      }
    });
  }

  ngOnDestroy(): void {
    this.scrollSyncSub?.unsubscribe();
  }
}
